import { render, staticRenderFns } from "./SettingsTitleBar.vue?vue&type=template&id=4a4108a8&scoped=true&"
import script from "./SettingsTitleBar.vue?vue&type=script&lang=ts&"
export * from "./SettingsTitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsTitleBar.vue?vue&type=style&index=0&id=4a4108a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4108a8",
  null
  
)

export default component.exports